import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  // Trailing-slash normalization: /foo/ → /foo (keeps 1:1 blog/product redirect
  // matches working when legacy Woo URLs include the trailing slash).
  useEffect(() => {
    if (pathname.length > 1 && pathname.endsWith('/')) {
      const stripped = pathname.replace(/\/+$/, '') || '/';
      navigate({ pathname: stripped, search, hash }, { replace: true });
    }
  }, [pathname, search, hash, navigate]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
